.root[data-glass-page-tabs="true"] {
  --glass-theme-text: rgba(
    var(--glass-color-black, 0 0 0) / var(--glass-opacity-90, 0.9)
  );
  --glass-theme-text-secondary: rgba(
    var(--glass-color-black, 0 0 0) / var(--glass-opacity-70, 0.7)
  );
  --glass-theme-text-tertiary: rgba(
    var(--glass-color-black, 0 0 0) / var(--glass-opacity-65, 0.65)
  );
  --glass-page-tabs-ink: rgba(
    var(--glass-color-black, 0 0 0) / var(--glass-opacity-90, 0.9)
  );
  --glass-page-tabs-ink-secondary: rgba(
    var(--glass-color-black, 0 0 0) / var(--glass-opacity-70, 0.7)
  );
  --glass-page-tabs-ink-disabled: rgba(
    var(--glass-color-black, 0 0 0) / var(--glass-opacity-40, 0.4)
  );
  --glass-page-tabs-backdrop-filter: blur(
      var(--aura-glass-neutral-level2-backdrop-blur, 24px)
    )
    var(--glass-filter-base, saturate(1.8) brightness(1.05) contrast(1.05));
  --glass-elev-page-tabs-surface:
    inset 0 1px 0 rgba(var(--glass-color-white, 255 255 255) / 0.32),
    0 0 0 1px rgba(var(--glass-color-black, 0 0 0) / 0.07),
    0 12px 32px rgba(var(--glass-color-black, 0 0 0) / 0.08);
  --glass-elev-page-tabs-hover: inset 0 1px 0
    rgba(var(--glass-color-white, 255 255 255) / 0.3);
  --glass-elev-page-tabs-focus:
    0 0 0 2px rgba(var(--glass-color-white, 255 255 255) / 0.32),
    0 0 0 4px rgba(var(--glass-color-black, 0 0 0) / 0.42),
    inset 0 1px 0 rgba(var(--glass-color-white, 255 255 255) / 0.3);
  --glass-elev-page-tabs-selected:
    inset 0 1px 0 rgba(var(--glass-color-white, 255 255 255) / 0.32),
    0 0 0 1px rgba(var(--glass-color-black, 0 0 0) / 0.06),
    0 5px 14px rgba(var(--glass-color-black, 0 0 0) / 0.1);
  --glass-elev-page-tabs-badge:
    inset 0 1px 0 rgba(var(--glass-color-white, 255 255 255) / 0.3),
    0 1px 3px rgba(var(--glass-color-black, 0 0 0) / 0.06);
  display: grid;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  gap: var(--glass-space-4, 1rem);
  border-radius: var(--glass-radius-lg, 24px);
  color: var(--glass-page-tabs-ink);
  isolation: isolate;
}

.horizontal {
  grid-template-columns: minmax(0, 1fr);
}

.vertical {
  grid-template-columns: minmax(10rem, 13.75rem) minmax(0, 1fr);
  align-items: start;
}

.tabList,
.panel {
  position: relative;
  min-width: 0;
  border: 1px solid rgba(var(--glass-color-white, 255 255 255) / 0.32);
  background-clip: padding-box;
  backdrop-filter: var(--glass-page-tabs-backdrop-filter);
  -webkit-backdrop-filter: var(--glass-page-tabs-backdrop-filter);
  box-shadow: var(--glass-elev-page-tabs-surface);
}

.tabList::before,
.panel::before {
  position: absolute;
  inset: 0;
  z-index: 0;
  border-radius: inherit;
  background: linear-gradient(
    180deg,
    rgba(var(--glass-color-white, 255 255 255) / 0.32) 0%,
    rgba(var(--glass-color-white, 255 255 255) / 0.18) 36%,
    rgba(var(--glass-color-white, 255 255 255) / 0.08) 68%
  );
  content: "";
  pointer-events: none;
}

.tabList {
  display: flex;
  align-items: stretch;
  width: 100%;
  gap: var(--glass-space-1, 0.25rem);
  padding: var(--glass-space-1, 0.25rem);
  overflow: visible;
  border-radius: var(--glass-radius-md, 16px);
  background-color: rgba(var(--glass-color-white, 255 255 255) / 0.28);
}

.horizontalList {
  flex-direction: row;
}

.verticalList {
  flex-direction: column;
}

.trigger {
  position: relative;
  z-index: 1;
  display: inline-flex;
  min-width: 0;
  min-height: 2.5rem;
  align-items: center;
  justify-content: center;
  gap: var(--glass-space-2, 0.5rem);
  margin: 0;
  padding: var(--glass-space-2, 0.5rem) var(--glass-space-3, 0.75rem);
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid transparent;
  border-radius: var(--glass-radius-sm, 10px);
  background: transparent;
  box-shadow: none;
  color: var(--glass-page-tabs-ink-secondary);
  font: inherit;
  font-size: var(--glass-font-size-sm, 0.875rem);
  font-weight: var(--glass-font-medium, 500);
  line-height: var(--glass-leading-snug, 1.375);
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  touch-action: manipulation;
  transition:
    color var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-ease-standard, cubic-bezier(0.2, 0, 0, 1)),
    background-color var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-ease-standard, cubic-bezier(0.2, 0, 0, 1)),
    border-color var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-ease-standard, cubic-bezier(0.2, 0, 0, 1)),
    box-shadow var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-ease-standard, cubic-bezier(0.2, 0, 0, 1)),
    transform var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-ease-standard, cubic-bezier(0.2, 0, 0, 1));
}

.verticalList .trigger {
  width: 100%;
  justify-content: space-between;
  text-align: start;
}

.trigger:not(:disabled):not(.selected):hover {
  border-color: rgba(var(--glass-color-white, 255 255 255) / 0.3);
  background-color: rgba(var(--glass-color-white, 255 255 255) / 0.3);
  box-shadow: var(--glass-elev-page-tabs-hover);
  color: var(--glass-page-tabs-ink);
}

.trigger:not(:disabled):active {
  transform: scale(0.985);
}

.root .trigger:focus-visible {
  z-index: 2;
  outline: none;
  box-shadow: var(--glass-elev-page-tabs-focus);
}

.selected {
  border-color: rgba(var(--glass-color-white, 255 255 255) / 0.32);
  background: linear-gradient(
    180deg,
    rgba(var(--glass-color-white, 255 255 255) / 0.32) 0%,
    rgba(var(--glass-color-white, 255 255 255) / 0.22) 100%
  );
  box-shadow: var(--glass-elev-page-tabs-selected);
  color: var(--glass-page-tabs-ink);
}

.trigger:disabled {
  color: var(--glass-page-tabs-ink-disabled);
  cursor: not-allowed;
  opacity: var(--glass-opacity-45, 0.45);
}

.triggerLabel {
  min-width: 0;
}

.badge {
  display: inline-flex;
  min-width: 1.5rem;
  min-height: 1.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0.0625rem var(--glass-space-2, 0.5rem);
  border: 1px solid rgba(var(--glass-color-white, 255 255 255) / 0.3);
  border-radius: var(--glass-radius-full, 9999px);
  background: linear-gradient(
    180deg,
    rgba(var(--glass-color-white, 255 255 255) / 0.3),
    rgba(var(--glass-color-white, 255 255 255) / 0.2)
  );
  box-shadow: var(--glass-elev-page-tabs-badge);
  color: inherit;
  font-size: var(--glass-font-size-xs, 0.75rem);
  font-weight: var(--glass-font-semibold, 600);
  line-height: var(--glass-leading-snug, 1.375);
}

.panel {
  width: 100%;
  padding: var(--glass-space-5, 1.25rem);
  overflow-wrap: anywhere;
  border-radius: var(--glass-radius-md, 16px);
  background-color: rgba(var(--glass-color-white, 255 255 255) / 0.28);
  color: var(--glass-page-tabs-ink);
}

.panel > * {
  position: relative;
  z-index: 1;
  min-width: 0;
  max-width: 100%;
}

.root .panel:focus-visible {
  outline: 2px solid rgba(var(--glass-color-black, 0 0 0) / 0.42);
  outline-offset: 3px;
}

@media (max-width: 40rem) {
  .vertical {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 36rem) {
  .horizontalList {
    flex-wrap: wrap;
  }

  .horizontalList .trigger {
    min-width: 0;
    min-height: 2.75rem;
    flex: 1 1 auto;
    white-space: normal;
  }

  .horizontalList .triggerLabel {
    overflow-wrap: anywhere;
  }

  .panel {
    padding: var(--glass-space-4, 1rem);
  }
}

@media (prefers-reduced-motion: reduce) {
  .trigger {
    transition-duration: 0.01ms;
  }

  .trigger:not(:disabled):active {
    transform: none;
  }
}

@media (prefers-reduced-transparency: reduce) {
  .root[data-glass-page-tabs="true"] {
    --glass-page-tabs-backdrop-filter: none;
  }

  .tabList,
  .panel {
    background: rgba(var(--glass-color-white, 255 255 255) / 0.96);
  }
}

@media (forced-colors: active) {
  .root[data-glass-page-tabs="true"] {
    --glass-page-tabs-ink: CanvasText;
    --glass-page-tabs-ink-secondary: CanvasText;
    --glass-page-tabs-ink-disabled: GrayText;
  }

  .tabList,
  .panel,
  .trigger,
  .badge {
    border-color: CanvasText;
    background: Canvas;
    box-shadow: none;
    color: CanvasText;
    forced-color-adjust: auto;
  }

  .root .trigger:focus-visible,
  .root .panel:focus-visible {
    outline: 2px solid Highlight;
    outline-offset: 2px;
  }
}
